import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.932 2.573c.26-.26.26-.68 0-.94l-.939-.938a.664.664 0 1 0-.94.939l.94.939c.26.26.68.26.94 0M2.2.695a.664.664 0 0 1 .94.939l-.94.94a.664.664 0 0 1-.94-.94zM8.76 4.21a.664.664 0 0 0-1.328 0v3.985c0 .251.142.481.367.594l2.657 1.328a.664.664 0 0 0 .594-1.188L8.76 7.784z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.096.889a7.305 7.305 0 1 0 0 14.611 7.305 7.305 0 0 0 0-14.611M2.12 8.194a5.977 5.977 0 1 1 11.955 0 5.977 5.977 0 0 1-11.955 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })